export default "__VITE_ASSET___88I93eY__"